// Renders clock times with a zero-based midnight/noon hour ("00:05am"
// instead of the Intl default "12:05 AM") and a lowercase am/pm marker.
export function formatClockTime(
  date: Date,
  options: Intl.DateTimeFormatOptions = {}
): string {
  return date
    .toLocaleTimeString("en-US", {
      timeZone: "Asia/Kolkata",
      hourCycle: "h11",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      ...options,
    })
    .replace(" ", "")
    .toLowerCase();
}
